/**
 * The top-level MobX State Tree.
 */
import { types, flow, type Instance } from 'mobx-state-tree';
import Projects from './projects';
import Auth from './auth';
import UI from './ui';

const RootStore = types
  .model('RootStore', {
    projects: types.optional(Projects, () => Projects.create({})),
    auth: types.optional(Auth, () => Auth.create({})),
    ui: types.optional(UI, () => UI.create({})),
  })
  .views(self => ({}))
  .actions(self => ({
    /**
     * Logout the user and clear the ui and projects stores.
     */
    logout: flow(function* logout() {
      yield self.auth.logout();
      // Reset both stores to their defaults by assigning an empty snapshot. MST
      // hydrates `{}` into a fresh store at runtime; the instance write type
      // doesn't accept the snapshot shape, so cast at these assignments.
      self.ui = {} as unknown as typeof self.ui;
      self.projects = {} as unknown as typeof self.projects;
    }),
  }));

export type IRootStore = Instance<typeof RootStore>;

export default RootStore;
